import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Defeat CDN/proxy caching of GET responses on the deployed site so lists
  // (OIHR, reminders, tasks …) always reflect the latest data when polled.
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _t: Date.now() };
    config.headers["Cache-Control"] = "no-cache";
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Normalize FastAPI 422 validation errors so `detail` is always a renderable string.
    // This prevents "Objects are not valid as a React child" when `detail` is an array/object.
    const d = err.response?.data?.detail;
    if (d != null && typeof d !== "string") {
      err.response.data.detail = formatApiErrorDetail(d);
    }
    if (err.response?.status === 401 && localStorage.getItem("ap_token")) {
      localStorage.removeItem("ap_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
